import * as React from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";

import { cn } from "../../utils";

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, value, ...props }, ref) => {
  const normalizedValue = value ?? 0;
  const translateValue = 100 - normalizedValue;
  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn(
        "al-relative al-h-4 al-w-full al-overflow-hidden al-rounded-full al-bg-secondary",
        className
      )}
      value={normalizedValue}
      {...props}
    >
      <ProgressPrimitive.Indicator
        role="presentation"
        aria-label="Progress indicator"
        className="al-h-full al-w-full al-flex-1 al-bg-primary al-transition-all"
        style={{
          transform: translateValue === 0 ? "translateX(0%)" : `translateX(-${translateValue}%)`,
        }}
      />
    </ProgressPrimitive.Root>
  );
});
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
